import { z } from 'zod'

export const FAMILY_ROLES = [
  'adult_earner',
  'adult_dependent',
  'child',
  'senior',
  'pet',
] as const
export const FamilyRoleSchema = z.enum(FAMILY_ROLES)
export type FamilyRole = z.infer<typeof FamilyRoleSchema>

export const AREA_CODES = [
  'property_building',
  'property_home',
  'property_glass',
  'property_theft',
  'vehicle_mtpl',
  'vehicle_casco',
  'vehicle_glass',
  'vehicle_assistance',
  'vehicle_gap',
  'life',
  'accident',
  'disability_invalidity',
  'sick_leave',
  'critical_illness',
  'hospital_daily',
  'health_supplemental',
  'liability_personal',
  'child_accident',
  'mortgage_protection',
  'liability_employee',
  'liability_professional',
  'unemployment',
  'travel',
  'travel_cancellation',
  'travel_luggage',
  'travel_sport',
  'pet',
  'pet_liability',
  'legal_protection',
  'cyber',
] as const
export const AreaCodeSchema = z.enum(AREA_CODES)
export type AreaCode = z.infer<typeof AreaCodeSchema>

export const ContractStatusSchema = z.enum(['pending_confirm', 'confirmed'])
export type ContractStatus = z.infer<typeof ContractStatusSchema>

export const PremiumFrequencySchema = z.enum(['annual', 'semi_annual', 'quarterly', 'monthly'])
export type PremiumFrequency = z.infer<typeof PremiumFrequencySchema>

export const RecommendationSeveritySchema = z.enum(['critical', 'high', 'medium', 'low'])
export type RecommendationSeverity = z.infer<typeof RecommendationSeveritySchema>

export const RecommendationKindSchema = z.enum([
  'missing_area',
  'missing_person',
  'expiring_soon',
  'underinsured',
  'overinsured',
  'portfolio_risk',
])
export type RecommendationKind = z.infer<typeof RecommendationKindSchema>

export const ZONE_IDS = [
  'house',
  'vehicle',
  'person',
  'family',
  'work',
  'travel',
  'pet',
] as const
export const ZoneIdSchema = z.enum(ZONE_IDS)
export type ZoneId = z.infer<typeof ZoneIdSchema>

export const ZoneStateValueSchema = z.enum(['covered', 'partial', 'missing'])
export type ZoneStateValue = z.infer<typeof ZoneStateValueSchema>

export const OcrProviderSchema = z.enum(['mock', 'claude'])
export type OcrProvider = z.infer<typeof OcrProviderSchema>
